import React from "react";
import PublicLegalPage from "./PublicLegalPage";

const PublicPrivacyPolicy = () => (
  <PublicLegalPage
    apiPath="cms/privacy"
    fallbackTitleEn="Privacy Policy"
    fallbackTitleAr="سياسة الخصوصية"
  />
);

export default PublicPrivacyPolicy;
